import { Injectable } from '@angular/core';
// import { HttpClient, HttpParams } from '@angular/common/http';
import { logoProdfor } from 'environments/image-resource';
// import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
// import { environment } from 'environments/environment';
import * as jsPDF from 'jspdf';
import * as pdf from './pdf';

declare var jsPDF: any; // Important

@Injectable()
export class PdfService {
    private doc: jsPDF; /* = new jsPDF('landscape', 'pt'); */
    private zerarPosY = false;

    constructor() { }

    /**
     * Recupera as informações para montar a tabela
     */
    public geraPdf(rows, columns, nomeArquivo, dataEvento, nomeEvento, nomeHeader, nomeTabela) {
        pdf.geratabela(columns, rows, this.zerarPosY, dataEvento, nomeEvento, nomeHeader, nomeTabela);
        this.zerarPosY = false;
    }


    public InicializaPdf() {
        this.zerarPosY = true;
        pdf.inicializapdf();
        pdf.defImage(logoProdfor);
    }

    /**
     * Pega dados para montar uma tabela em formato PDF
     * @param dados Dados para preencher a tabela
     * @param columns Colunas da tabela
     * @param rows nomes dos campos de cada dado
     * @param nomeArquivo nome do arquivo que será baixado
     * @param dataEvento Data que irá ocorrer o evento
     * @param nomeEvento Nome do Evento
     * @param nomeHeader nome do Cabeçalho do pdf
     * @param nomeTabela Nome da tabela
     */
    public getDadosPdf(dados, columns, rows, nomeArquivo, dataEvento?, nomeEvento?, nomeHeader?, nomeTabela?) {
        const linhas = [];

        dados.forEach(item => {
            const aux = [];
            rows.forEach(itemDado => {
                aux.push(item[itemDado] ? item[itemDado] : '');
            });
            linhas.push(aux);
        });
        this.geraPdf(linhas, columns, nomeArquivo, dataEvento, nomeEvento, nomeHeader, nomeTabela);
    }
    public salvaPDf(nome) {
        return pdf.salvar(nome);
    }

    //--------------------- PDF GRAFICO ---------------------

    public inicializaPdfGrafico(){
        pdf.inicializaPdfGrafico();
        pdf.defImage(logoProdfor);
    }
    /**
     * Recupera as informações para montar o pdf do grafico
     * @param imgGrafico Imagem em jpeg do grafico
     */
    public geraPdfGrafico(titulo, imgGrafico, filtro, width?, height?) {
        pdf.geraPdfGrafico(titulo, imgGrafico, filtro, width, height);
    }

    public salvaPdfGrafico(nome) {
        return pdf.salvarGrafico(nome);
    }

}



// WEBPACK FOOTER //
// /app/src/app/services/pdf.service.ts